let gwpES6 = true

window.currencySymbol = '$'

window.API_VERSION = '2021-01'
window.API_ACCESS = '4003e104b00c45cb773f6285e0e1f40c'

class FostrGWP extends FostrCartItems {
  constructor() {
    super({
      name: 'Fostr GWP',
      version: '1.0.0'
    })

    this.cartState = undefined
    this.items = []
    this.cartGWP = document.querySelector('fostr-cart-gwp')
    this.previousTier = 0
    this.currentTier = 0
    this.nextTier = 0
    this.difference = 0
    this.price = 0
    this.addItems = []
    this.removeItems = {}
    this.gwpRemainingMsg = undefined
    this.checkGWPEligibilityCounter = 0
    this.gwpModalCloseCounterCookie = 'GWPCounter'
    this.gwpModalCloseCounter = 0
    this.gwpDisableModalCookie = 'GWPDisableModal'
    this.gwpDisableModalThreshold = 'GWPDisableModalThreshold'
    this.currentProductData = undefined
    this.minicart = document.querySelector('offcanvas-menu')
    this.sortedGWTPGifts = ''
    this.enableGWAP = !!gwpJSON.enableGWAP
    this.enableGWTP = !!gwpJSON.enableGWTP
    this.enableGWCP = !!gwpJSON.enableGWCP
    this.gwpTypes = [
      {
        method: 'gwap',
        type: 'auto',
        enabled: this.enableGWAP
      },
      {
        method: 'gwtp',
        type: 'threshold',
        enabled: this.enableGWTP
      },
      {
        method: 'gwcp',
        type: 'collection',
        enabled: this.enableGWCP
      }
    ]

    this.init()
  }

  async init() {
    console.log('GWPLOG:===========================================')
    console.log('GWPLOG:               run update')
    console.log('GWPLOG:===========================================')
    await this.updateCartData()

    this.gwtpNotifications()

    // Check if cart is empty
    if (!Object.values(this.items).length >= 1) return

    console.log('GWPLOG:📓 checking number of calls')
    if (this.checkGWPEligibilityCounter >= 1) return
    this.checkGWPEligibility()

    document
      .querySelectorAll('[data-gwtp-message]')
      .forEach(
        el =>
          (el.innerText = el.dataset.gwtpMessage.replace(
            '[[ amount ]]',
            window.currencySymbol + el.dataset.gwtpThreshold
          ))
      )
    document
      .querySelectorAll('[data-gwcp-message]')
      .forEach(
        el =>
          (el.innerText = el.dataset.gwcpMessage.replace(
            '[[ collection ]]',
            el.dataset.gwcpCollection
          ))
      )

    this.runGWP()
  }

  loading(bool) {
    const minicart = document.getElementById('fostr-mini-cart-items')

    if (minicart) {
      let loadingOverlay = minicart.querySelector(':scope > .loading-overlay')
      if (!!bool) {
        console.log('GWPLOG:📓 loading...')
        if (loadingOverlay) {
          loadingOverlay.classList.remove('hidden')
        }
        minicart.style.overflow = 'hidden'
      } else {
        console.log('GWPLOG:📓 finished loading')
        if (loadingOverlay) {
          loadingOverlay.classList.add('hidden')
        }
        minicart.style.overflow = ''
      }
    }
  }

  async updateCartData() {
    const getCart = await fetch('/cart.js', { method: 'GET' })
    const cartState = await getCart.json()

    this.cartState = cartState
    window.cartState = cartState
    this.price = this.cartState.total_price / 100
    this.items = new Proxy(cartState.items, {})

    this.sortedGWTPGifts = Object.values(gwpJSON.GWPGifts).sort(
      (a, b) => a.value - b.value
    )
    this.currentTier =
      parseInt(
        Object.values(
          Object.values(this.sortedGWTPGifts).filter(
            gift => gift.type === 'threshold'
          )
        )
          .filter(gift => this.price >= gift.value)
          .reverse()[0]?.value
      ) || 0
    this.previousTier =
      this.items
        .filter(item => item.properties?._gwpType === 'threshold')
        .filter(item => item.properties._gwpThreshold != this.currentTier)[0]
        ?.properties._gwpThreshold || 0
    this.nextTier =
      parseInt(
        Object.values(
          Object.values(this.sortedGWTPGifts).filter(
            gift => gift.type === 'threshold'
          )
        ).filter(gift => this.price < parseInt(gift.value))[0]?.value
      ) || 0
    this.difference = (
      !!this.nextTier ? this.nextTier - this.price : 0
    ).toFixed(2)
  }

  runGWP() {
    this.gwpTypes
      .filter(obj => obj.enabled)
      .forEach(enabledObj =>
        this[enabledObj.method](
          Object.values(gwpJSON.GWPGifts).filter(
            gift => gift.type === enabledObj.type
          ),
          enabledObj.type
        )
      )

    console.log('GWPLOG:📓 checking add/remove items array')

    if (
      this.addItems.length === 0 &&
      Object.values(this.removeItems).length === 0
    ) {
      console.log(
        'GWPLOG:📔 empty add: ',
        JSON.parse(JSON.stringify(this.addItems))
      )
      console.log(
        'GWPLOG:📔 empty remove: ',
        JSON.parse(JSON.stringify(this.removeItems))
      )
      console.log('GWPLOG:📔 nothing to update')
      this.loading(false)
    }

    if (Object.values(this.removeItems).length > 0) {
      console.log('GWPLOG:📕 remove products in removeItems array')
      console.log(
        'GWPLOG:📕 remove: ',
        JSON.parse(JSON.stringify(this.removeItems))
      )
      this.cartGWP.removeItems(this.removeItems)
    }

    if (this.addItems.length > 0) {
      console.log('GWPLOG:📗 add products in addItems array')
      console.log('GWPLOG:📗 add: ', JSON.parse(JSON.stringify(this.addItems)))
      this.cartGWP.addItem(this.addItems)
    }

    this.checkGWPEligibilityCounter = 0
  }

  async checkGWPEligibility() {
    console.log('GWPLOG:📓 checking GWP eligibility')
    if (this.checkGWPEligibilityCounter >= 1) return
    this.checkGWPEligibilityCounter = this.checkGWPEligibilityCounter + 1
    console.log(
      `GWPLOG:📓 checkGWPEligibility called ${this.checkGWPEligibilityCounter} time(s)`
    )

    console.log('ran eligability checkssss')

    this.loading(true)

    // Remove gift from cart if GWP type is disabled
    this.gwpTypes
      .filter(obj => !obj.enabled)
      .forEach(disabledObj =>
        this.removeIneligibleGiftsFromCart(disabledObj.type)
      )

    this.checkForDuplicateGifts()

    if (
      window.cartState.items.every(item => item.properties?._giftId) ||
      (window.cartState.items.filter(e => e.handle === 'giftcard').length > 0 &&
        window.cartState.items.some(item => item.properties?._giftId) &&
        window.cartState.items.length <= 3)
    ) {
      console.log(
        'GWPLOG:📕 remove gift product if its the only item in the cart'
      )
      window.cartState.items.forEach(item => {
        if (!item.properties?._giftId) return
        this.cartGWP.removeItems({ [item.key]: 0 })
        // if(window.cartState.items.filter(e => e.handle === "giftcard").length > 0){
        //   return
        // }
        if (!item.properties?._giftId) return
      })
    }
  }

  removeIneligibleGiftsFromCart(gwpType) {
    console.log(
      `GWPLOG:📘 Running removeIneligibleGiftsFromCart(${gwpType})...`
    )
    const gifts = window.cartState.items.filter(
      item => item.properties?._gwpType
    )
    const ineligibleGifts = gifts.filter(item =>
      item.properties._gwpType.includes(gwpType)
    )

    // Remove gifts from disabled GWP types
    if (gifts.some(item => item.properties._gwpType.includes(gwpType))) {
      console.log(`GWPLOG:📕 ${gwpType} gifts aren't enabled`)

      ineligibleGifts.forEach(item => {
        console.log(`GWPLOG:📕 remove ineligible ${gwpType} gift`)
        this.removeItems = { ...this.removeItems, [item.key]: 0 }
      })
    }
  }

  checkForDuplicateGifts() {
    console.log('GWPLOG:📓 checking for duplicate gifts...')
    const items = window.cartState.items
    const giftsWithMultipleQuantities = items.filter(
      item => item.properties?._giftId && item.quantity > 1
    )

    if (items.filter(item => item.properties?._giftId).length < 1) {
      console.log('GWPLOG:📔 no gifts found')
      return
    }

    if (
      items.filter(item => item.properties?._gwpType === 'threshold').length ===
      1
    ) {
      console.log('GWPLOG:📔 no duplicate threshold gifts found')
    }

    // Remove line item duplicates
    if (giftsWithMultipleQuantities.length > 0) {
      giftsWithMultipleQuantities.forEach(item => {
        console.log('GWPLOG:📕 set line item quantity to 1')
        this.removeItems = { ...this.removeItems, [item.key]: 1 }
      })
    }

    // Remove duplicate gift with any purchase
    if (this.enableGWAP) {
      if (
        items.filter(item => item.properties._gwpType === 'auto').length > 1
      ) {
        console.log('GWPLOG:📕 remove duplicate any gift')
        this.removeItems = {
          ...this.removeItems,
          [items.filter(item => item.properties._gwpType === 'auto')[0].key]: 0
        }
      }
    }

    // Remove duplicate threshold gifts
    if (this.enableGWTP) {
      if (
        items.filter(item => item.properties._gwpType === 'threshold').length >
          1 &&
        items.filter(item => item.properties._gwpThreshold === this.currentTier)
          .length > 1
      ) {
        console.log('GWPLOG:📘 more than one with same threshold')
        console.log('GWPLOG:📘 current threshold is', this.currentTier)
        console.log(
          'GWPLOG:📘 ',
          items.filter(
            item => item.properties._gwpThreshold === this.currentTier
          )
        )
        this.removeItems = {
          ...this.removeItems,
          [items.filter(
            item => item.properties._gwpThreshold === this.currentTier
          )[0].key]: 0
        }
      }
    }
  }

  gwap(data, type) {
    console.log('GWPLOG:📘 Running GWAP...')
    console.log('GWPLOG:📘 use case 1')

    if (this.cartState.items.length < 1) return

    let eligibleProductCount = 0
    for (let i = 0; i < this.cartState.items.length; i++) {
      if (
        this.cartState.items[i].handle !== 'giftcard' &&
        !this.cartState.items[i].properties._giftId
      ) {
        eligibleProductCount++
      }
    }

    if (eligibleProductCount < 1) return

    if (
      window.cartState.items.some(
        item => item.properties._gwpType === 'auto'
      ) &&
      this.cartState.items.length === 0
    ) {
      console.log('GWPLOG:📕 removing auto gift')
      this.addGiftToRemoveItems('auto')
    }

    if (
      window.cartState.items.some(item => item.properties._gwpType === 'auto')
    )
      return
    if (window.cartState.items.every(item => item.properties._giftId)) return

    if (data.length > 1) {
      console.log('GWPLOG:📘 more than 1 gift product')
      console.log('GWPLOG:📘 AUTO GIFT')
      this.triggerGWPModal(type)
    } else if(data.length === 1) {
      console.log('GWPLOG:📘 AUTO GIFT')
      this.addGiftToAddItems(data[0].id, type)
    }
  }

  async gwtp(data, type) {
    console.log('GWPLOG:📘 Running GWTP...')

    let eligibleProductCount = 0
    let eligibleProductSubtotal = this.price
    for (let i = 0; i < this.cartState.items.length; i++) {
      if (this.cartState.items[i].handle === 'giftcard') {
        eligibleProductSubtotal =
          eligibleProductSubtotal - this.cartState.items[i].price / 100
      } else if (!this.cartState.items[i].properties._giftId) {
        eligibleProductCount++
      }
    }

    if (eligibleProductCount < 1) return

    const giftsInTier = Object.values(data).filter(
      gift => this.currentTier === parseInt(gift.value)
    )
    const modalCookieThreshold =
      parseInt(this.checkCookie(this.gwpDisableModalThreshold)) ||
      this.currentTier

    if (this.currentTier.threshold !== modalCookieThreshold) {
      this.disableGWPModalCookies()
    }

    console.log('GWPLOG:📓 checking for gifts out of threshold')
    if (
      this.items
        .filter(item => item.properties._gwpType === 'threshold')
        .some(item => item.properties._gwpThreshold != this.currentTier)
    ) {
      console.log('GWPLOG:📘 contains non tier product')
      this.addGiftToRemoveItems('threshold', this.previousTier)
    } else {
      console.log('GWPLOG:📔 nothing to remove')
    }

    if (
      !Object.values(this.sortedGWTPGifts).some(
        gift => this.price >= gift.value
      )
    )
      return
    if (
      window.cartState.items.some(
        item => item.properties._gwpThreshold === this.currentTier
      )
    )
      return

    console.log('GWPLOG:📘 use case 2')
    console.log('GWPLOG:📘 GIFT AT THRESHOLD')

    if (giftsInTier.length > 1) {
      console.log('GWPLOG:📘 more than 1 gift product')
      this.triggerGWPModal(giftsInTier[0].type, this.currentTier)
    } else {
      console.log('GWPLOG:📘 1 gift product')
      this.addGiftToAddItems(giftsInTier[0].id, type, this.currentTier)
    }
  }

  gwcp(data, type) {
    console.log('GWPLOG:📘 Running GWCP...')
    const gwpCollections = gwpJSON.GWPCollections
    const eligibleCollections = []
    const ineligibleCollections = []

    const threshold = gwpJSON.threshold
    const sourceCollection = gwpJSON.sourceCollection

    if (threshold && this.price < threshold) {
      console.log('Threshold NOT MET')
      return this.addGiftToRemoveItems(type, 0, true)
    }
    if (sourceCollection) {
      const doesCartContainItemInSourceCollection = this.items.some(item =>
        sourceCollection.some(i => i === item.variant_id)
      )
      console.log(
        this.items.map(i => i.variant_id),
        sourceCollection
      )
      if (!doesCartContainItemInSourceCollection)
        return this.addGiftToRemoveItems(type, 0, true)
    }

    Object.entries(gwpCollections).forEach(([collectionName, products]) => {
      if (
        products.some(product =>
          this.items.some(
            item =>
              item.handle === product &&
              !Object.keys(item.properties).some(prop => prop === '_giftId')
          )
        )
      ) {
        eligibleCollections.push(collectionName)
      } else {
        ineligibleCollections.push(collectionName)
      }
    })
    console.log(
      'GWPLOG:📘 a line item is in a collection:',
      eligibleCollections.length > 0
    )

    data.forEach(gift => {
      const giftCount = data.filter(obj => obj.value === gift.value).length

      if (
        this.items.some(item =>
          ineligibleCollections.includes(item.properties._gwpCollection)
        )
      ) {
        console.log(
          'GWPLOG:📔 no line items are in these collections:',
          this.items.filter(item =>
            ineligibleCollections.includes(item.properties._gwpCollection)
          )
        )
        if (
          this.items.filter(
            item =>
              item.properties._gwpType === 'collection' &&
              ineligibleCollections.includes(item.properties._gwpCollection)
          )
        ) {
          this.addGiftToRemoveItems(type)
        }
      }

      if (eligibleCollections.includes(gift.value)) {
        console.log(
          'GWPLOG:📘 a line item is in one of these collections:',
          eligibleCollections
        )
        console.log('GWPLOG:📘 use case 3')
        console.log('GWPLOG:📘 COLLECTION GIFT')

        if (
          this.items.filter(
            item => item.properties._gwpCollection === gift.value
          ).length > 1
        ) {
          this.addGiftToRemoveItems(type, gift.value)
        }

        if (
          this.items.some(item => item.properties._gwpCollection === gift.value)
        )
          return

        if (
          !this.items.some(
            item =>
              item.id === gift.id &&
              item.properties._gwpType?.includes('collection')
          )
        ) {
          if (giftCount > 1) {
            console.log('GWPLOG:📘 more than 1 gift product')
            this.triggerGWPModal(type, gift.value)
          } else {
            console.log('GWPLOG:📘 1 gift product')
            this.showGiftCarousel(type, gift)
          }
        }
      }
    })
  }

  showGiftCarousel(type, gift) {
    console.log('Showing gift carousel')
    const targetCollection = gwpJSON.targetCollection
    const sectionId = 'fostr-cart-drawer'
    fetch(window.Shopify.routes.root + `?sections=${sectionId}`).then(res => {
      const cartMarkup = res.json()
    })

    // this.addGiftToAddItems(gift.id, type, gift.value)
  }

  gwtpNotifications() {
    if (!this.enableGWTP) return
    const nextTierProducts = Object.values(
      Object.values(this.sortedGWTPGifts).filter(
        gift => gift.type === 'threshold'
      )
    ).filter(gift => this.nextTier === parseInt(gift.value))
    const gwpUpsellTitle = document.querySelectorAll(
      '.fostr-gwp-upsells .cart-item__name a'
    )
    const gwpUpsellMainTitle = document.querySelectorAll(
      '.fostr-gwp-upsells .cart-item__name .product-title--main'
    )
    const gwpUpsellSubTitle = document.querySelectorAll(
      '.fostr-gwp-upsells .cart-item__name .product-title--sub'
    )
    const gwpUpsellImageWrapper = document.querySelector(
      '.fostr-gwp-upsells .cart-item__media'
    )
    const gwpUpsellIcon = document.querySelector('.fostr-gwp-message-icon')
    let gwpUpsellImage = document.querySelectorAll(
      '.fostr-gwp-upsells .cart-item__image'
    )
    const gwpUpsellMsg = document.querySelectorAll('[data-gwp-upsell-msg]')
    const gwpUpsellMsgContent = document.querySelector('[data-gwp-upsell-msg]')
      ?.dataset.gwpUpsellMsg
    const gwpUpsellMultipleMsgContent = document.querySelector(
      '[data-gwp-upsell-multiple-msg]'
    )?.dataset.gwpUpsellMultipleMsg

    const gwpUpsellHeadings = document.querySelector(
      '.fostr-gwp-upsells .upsell-headings'
    )

    if (gwpUpsellHeadings) {
      gwpUpsellHeadings.innerText =
        gwpUpsellHeadings.dataset.gwpUpsellHeading.replace(
          '[[ amount ]]',
          window.currencySymbol + this.nextTier
        )
    }

    if (this.nextTier === 0) {
      document
        .querySelectorAll('.fostr-gwp-upsells')
        .forEach(el => el.classList.add('hidden'))
      this.loading(false)
    } else {
      document
        .querySelectorAll('.fostr-gwp-upsells')
        .forEach(el => el.classList.remove('hidden'))

      if (Object.keys(nextTierProducts).length > 1) {
        gwpUpsellMainTitle.forEach(
          el =>
            (el.innerText = gwpUpsellTitle[0].dataset.gwpUpsellMultipleTitle)
        )
        gwpUpsellSubTitle.forEach(el => (el.innerText = ''))
        gwpUpsellImage.forEach(el => (el.src = gwpJSON.GWPImages.gwtpImage))
        gwpUpsellMsg.forEach(
          el =>
            (el.innerText = gwpUpsellMultipleMsgContent.replace(
              '[[ amount ]]',
              this.difference
            ))
        )
      } else {
        let mainTitle = window.titleize(nextTierProducts[0].title.toLowerCase())

        if (mainTitle.includes('(')) {
          mainTitle = window.titleize(
            nextTierProducts[0].title.split('(')[0].toLowerCase()
          )
          let subTitle = window.titleize(
            nextTierProducts[0].title
              .split('(')
              .reverse()[0]
              .replace(')', '')
              .toLowerCase()
          )

          gwpUpsellSubTitle.forEach(el => (el.innerText = subTitle))
        }

        if (!!gwpUpsellIcon) {
          gwpUpsellImage = document.createElement('img')
          gwpUpsellImage.classList.add('cart-item__image')
          gwpUpsellImageWrapper.append(gwpUpsellImage)
          gwpUpsellImageWrapper
            .querySelector('.fostr-gwp-message-icon')
            .remove()
          gwpUpsellImage.src = nextTierProducts[0].liquidImage
        } else {
          gwpUpsellImage.forEach(
            el => (el.src = nextTierProducts[0].liquidImage)
          )
        }

        gwpUpsellMainTitle.forEach(el => (el.innerText = mainTitle))
        gwpUpsellTitle.forEach(
          el => (el.href = '/products/' + nextTierProducts[0].handle)
        )
        gwpUpsellMsg.forEach(
          el =>
            (el.innerText = gwpUpsellMsgContent.replace(
              '[[ amount ]]',
              this.difference
            ))
        )
      }
    }
  }

  async triggerGWPModal(modalType, currentTier = 0) {
    console.log('GWPLOG:📘 trigger GWP modal')
    const productWrapper = document.querySelectorAll(
      'fostr-menu-carousel-component.fostr-gwp-modal__slider'
    )
    const setSubtitlePrice = document
      .querySelector('.gwtp-modal__subtitle')
      .innerHTML.replace('[[ amount ]]', window.currencySymbol + currentTier)
    const setCollectionName = document
      .querySelector('.gwcp-modal__subtitle')
      .innerHTML.replace('[[ collection ]]', currentTier)
    const gwpTypes = ['threshold', 'collection']

    let modal = document.querySelector('.gwp-modal')

    if (!modal) return
    modal.dataset.gwpType = modalType

    let modalSubTitle = modal.querySelector('.gwtp-modal__subtitle')
    if (modalSubTitle) {
      modalSubTitle.innerText = setSubtitlePrice
    }

    modalSubTitle = modal.querySelector('.gwcp-modal__subtitle')
    if (modalSubTitle) {
      modalSubTitle.innerText = setCollectionName
    }

    if (modalType === 'threshold') {
      modalSubTitle.classList.remove('hidden')
    }

    if (modalType === 'collection') {
      document.querySelector('.gwcp-modal__subtitle').classList.remove('hidden')
    }

    productWrapper.forEach(item => (item.style.display = 'none'))

    if (modalType === 'auto') {
      document
        .querySelectorAll('[data-gwp-auto]')
        .forEach(
          item =>
            (item.closest('.fostr-gwp-modal__slider').style.display = 'block')
        )
    }

    gwpTypes.forEach(type => {
      if (modalType === type) {
        document
          .querySelectorAll(`[data-gwp-${type}="${currentTier}"]`)
          .forEach(
            item =>
              (item.closest('.fostr-gwp-modal__slider').style.display = 'block')
          )
      }
    })

    document.body.classList.add('overflow-hidden')
    let modalGwp = document.getElementById('ProductModal-GWP')
    if (modalGwp) {
      document.getElementById('ProductModal-GWP').setAttribute('open', '')
    }
  }

  async addGiftToAddItems(variantId, type, value = null) {
    let giftVariantId = parseInt(variantId)
    if (!giftVariantId) return
    if (this.addItems.some(item => item.id === giftVariantId)) return

    console.log('GWPLOG:📘 add GWP')
    const giftId = Math.floor(Math.random() * 1000000 + 1000)

    this.addItems.push({
      id: giftVariantId,
      quantity: 1,
      properties: {
        ...(!!value && { [`_gwp${window.capitalize(type)}`]: value }),
        _gwpType: type,
        _giftId: giftId
      }
    })
  }

  async addGiftToRemoveItems(type, currentVal = 0, thold = false) {
    const giftsInCart = window.cartState.items.filter(
      item => item.properties._gwpType
    )
    let giftVariantId
    console.log('current threshold is:', this.currentTier)

    giftsInCart.forEach(gift => {
      if (gift.properties._gwpType === 'threshold') {
        if (gift.properties[`_gwp${capitalize(type)}`] !== this.currentTier) {
          giftVariantId = gift.key
        }

        if (giftVariantId === undefined) return

        console.log(
          `GWPLOG:📕 removing ${type} gift`,
          gift.properties[`_gwp${capitalize(type)}`]
        )
        console.log('GWPLOG:📕 line item key to remove:', giftVariantId)
        this.removeItems = { ...this.removeItems, [giftVariantId]: 0 }
      }

      if (gift.properties._gwpType === 'collection') {
        if (!thold) {
          if (gift.properties[`_gwp${capitalize(type)}`] === currentVal) {
            giftVariantId = gift.key
          }

          if (giftVariantId === undefined) return

          console.log(
            `GWPLOG:📕 removing ${type} gift`,
            gift.properties[`_gwp${capitalize(type)}`]
          )
        } else {
          giftVariantId = gift.variant_id
        }
        console.log('GWPLOG:📕 line item key to remove:', giftVariantId)
        this.removeItems = { ...this.removeItems, [giftVariantId]: 0 }
      }
    })
  }

  checkCookie(param) {
    return document.cookie.split('; ').reduce((r, v) => {
      const parts = v.split('=')
      return parts[0] === param ? decodeURIComponent(parts[1]) : r
    }, '')
  }

  disableGWPModalCookies() {
    const expires = 'Thu, 01 Jan 1970 00:00:00 UTC'
    document.cookie =
      this.gwpDisableModalCookie + '=;expires=' + expires + '; path=/'
    document.cookie =
      this.gwpDisableModalThreshold + '=;expires=' + expires + '; path=/'
    document.cookie =
      this.gwpModalCloseCounterCookie + '=;expires=' + expires + '; path=/'
    document
      .querySelectorAll('.gwp-modal-disabled')
      .forEach(el => el.classList.add('hidden'))
    this.checkGWPEligibility()
  }

  closeModalCounter(threshold) {
    const expires = new Date(Date.now() + 1 * 864e5).toUTCString()
    const getGWPCounterValue = this.checkCookie(this.gwpModalCloseCounterCookie)

    this.gwpModalCloseCounter = getGWPCounterValue
      ? parseInt(getGWPCounterValue) + 1
      : this.gwpModalCloseCounter + 1

    document.cookie =
      this.gwpModalCloseCounterCookie +
      '=' +
      encodeURIComponent(this.gwpModalCloseCounter) +
      ';expires=' +
      expires +
      '; path=/'

    if (this.gwpModalCloseCounter >= 2) {
      document.cookie =
        this.gwpDisableModalCookie + '=true;expires=' + expires + '; path=/'
      document.cookie =
        this.gwpDisableModalThreshold +
        '=' +
        threshold +
        ';expires=' +
        expires +
        '; path=/'
      document
        .querySelectorAll('.gwp-modal-disabled')
        .forEach(el => el.classList.remove('hidden'))
    }
  }
}

customElements.define('fostr-gwp', FostrGWP)

class FostrCartGWP extends FostrCartDrawer {
  constructor() {
    super({
      name: 'Fostr Cart GWP',
      version: '1.0.0'
    })

    this.gwp = document.querySelector('fostr-gwp')
    this.sectionsToRender = []
  }

  // getSectionsToRender() {
  //   return this.sectionsToRender;
  // }

  addItem(items) {
    this.sectionsToRender = [
      {
        id: 'fostr-cart-drawer',
        selector: '#CartDrawer'
      },
      {
        id: 'fostr-cart-icon-bubble'
      },
    ]

    if (!items) {
      console.error('variant_id is required')
      return Promise.resolve(false)
    }

    const body = JSON.stringify({
      items: items,
      sections: this.getSectionsToRender().map(section => section.id),
      sections_url: window.location.pathname
    })

    return fetch(`${routes.cart_add_url}`, {
      ...fetchConfig('javascript'),
      body
    })
      .then(response => response.json())
      .then(parsedState => {
        this.renderContents(parsedState, true)
        this.disableLoading()

        console.log('GWPLOG:📗 ADD ITEMS: ', this.gwp.addItems)
        this.gwp.loading(false)
        this.gwp.addItems = []
        document
          .querySelectorAll('[data-gwtp-message]')
          .forEach(
            el =>
              (el.innerText = el.dataset.gwtpMessage.replace(
                '[[ amount ]]',
                window.currencySymbol + el.dataset.gwtpThreshold
              ))
          )

        return parsedState
      })
      .catch(err => {
        // this.querySelectorAll('.loading-overlay').forEach(overlay => overlay.classList.add('hidden'));
        console.error(err)
        document.getElementById('cart-errors').textContent =
          window.cartStrings.error
        this.disableLoading()
      })
  }

  removeItems(items) {
    this.sectionsToRender = [
      {
        id: 'fostr-cart-drawer',
        selector: '#CartDrawer'
      },
      {
        id: 'fostr-cart-icon-bubble'
      }
    ]

    const body = JSON.stringify({
      updates: items,
      sections: this.getSectionsToRender().map(section => section.id),
      sections_url: window.location.pathname
    })

    return fetch(`${routes.cart_update_url}`, { ...fetchConfig(), ...{ body } })
      .then(response => response.json())
      .then(parsedState => {
        this.renderContents(parsedState, true)
        const isEmpty = parsedState.sections['fostr-cart-drawer'].includes('is-empty')
        if(isEmpty) document.querySelector('fostr-cart-drawer').classList.add('is-empty')
        this.disableLoading()

        console.log('GWPLOG:📕 REMOVE ITEMS: ', this.gwp.removeItems)
        this.gwp.loading(false)
        this.gwp.removeItems = {}

        return parsedState
      })
      .catch(err => {
        // this.querySelectorAll('.loading-overlay').forEach(overlay => overlay.classList.add('hidden'));
        console.error(err)
        document.getElementById('cart-errors').textContent =
          window.cartStrings.error
        this.disableLoading()
      })
  }
}

customElements.define('fostr-cart-gwp', FostrCartGWP)

if (customElements.get('quick-buy')) {
  class QuickBuyGWP extends QuickBuy {
    constructor() {
      super()

      this.gwp = document.querySelector('fostr-gwp')
    }

    onClickHandler(event) {
      this.gwp.checkGWPEligibilityCounter = 0

      if (event.target.dataset.quickBuyFunction.length >= 1) {
        let altMethod = JSON.parse(event.target.dataset.quickBuyFunction)

        altMethod.forEach(method => {
          const gwpType = event.target.closest('gwp-modal').dataset.gwpType
          const giftId = event.target
            .closest('quick-buy-gwp')
            .getAttribute('variant-ids')

          if (gwpType === 'auto') {
            document
              .querySelector(method.component)
              [method.method](giftId, gwpType)
          } else if (gwpType === 'threshold') {
            document
              .querySelector(method.component)
              [method.method](
                giftId,
                gwpType,
                parseInt(
                  event.target.closest('fostr-menu-slide-component').dataset
                    .gwpThreshold
                )
              )
          } else if (gwpType === 'collection') {
            document
              .querySelector(method.component)
              [method.method](
                giftId,
                gwpType,
                event.target.closest('fostr-menu-slide-component').dataset
                  .gwpCollection
              )
          }
        })
      }

      document.body.classList.remove('overflow-hidden')
      document.getElementById('ProductModal-GWP').removeAttribute('open')
    }
  }

  customElements.define('quick-buy-gwp', QuickBuyGWP)
}

if (customElements.get('modal-dialog')) {
  class GWPModal extends ModalDialog {
    constructor() {
      super()
    }
  }
  customElements.define('gwp-modal', GWPModal)
}
